import { FILTER_KEY } from '@/ducks/filters/types';

export enum QF_SEARCH_PARAMS {
  quickFindID = 'quickFindID',
}

export const QF_ADDITIONAL_PARAMS = {
  dateFrom: FILTER_KEY.dateFrom,
  dateTo: FILTER_KEY.dateTo,
  itineraries: FILTER_KEY.destPackages,
  itinerariesRegions: FILTER_KEY.destPackagesRegions,
  ports: FILTER_KEY.destPorts,
  portsRegions: FILTER_KEY.destPortsRegions,
} as const;

export const QF_SAFE_CHANGE_PARAMS = [FILTER_KEY.sortType, FILTER_KEY.priceType];
